import {gql} from "@apollo/client";

export const getMeasurementsQuery = gql`
  query getMeasurements {
    measurements {
      id, date, formattedDate, details, weight, image, bust, waist, arms, legs, hips
    }
  }
`;

export const getChartMeasurementsQuery = gql`
  query getChartMeasurements {
    measurements {
      id, formattedDate, weight, waist
    }
  }
`;

export const getMeasurementsByIdQuery = gql`
  query getMeasurementById($id: ID!) {
    measurement( id: $id) {
      id, date, details, weight, image, bust, waist, arms, legs, hips
    }
  }
`;

export const saveMeasurementMutation = gql`
  mutation saveMeasurement($id: ID, $date: String!, $image: Upload, $details: String,
    , $weight: String!, $bust: String, $waist: String, $arms: String, $legs: String, $hips: String
  ){
    saveMeasurement(
      input: {
        id: $id,
        date: $date,
        image: $image,
        details: $details,
        weight: $weight,
        bust: $bust,
        waist: $waist,
        arms: $arms,
        legs: $legs,
        hips: $hips,
      }) {
      measurement {
        id
      }
    }
  }
`

export const deleteMeasurementMutation = gql`
  mutation deleteMeasurement($id: ID!){
    deleteMeasurement(
      input: {id: $id}) {
      measurement {
        id
      }
    }
  }
`